import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bell, CheckCheck } from "lucide-react";

const FILTERS = [["all", "Toutes"], ["unread", "Non lues"], ["read", "Lues"]];

export default function NotificationsPage() {
  const [notifs, setNotifs] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/notifications").then(({ data }) => setNotifs(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const unread = notifs.filter((n) => !n.read).length;
  const shown = notifs.filter((n) => filter === "all" ? true : filter === "unread" ? !n.read : !!n.read);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`).catch(() => {});
    setNotifs((prev) => prev.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };
  const markAll = async () => {
    await api.post("/notifications/read-all").catch(() => {});
    setNotifs((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="font-heading font-extrabold text-2xl tracking-tight flex items-center gap-2" data-testid="notifications-title">
            <Bell className="h-6 w-6 text-accent" /> Notifications
            {unread > 0 && <Badge className="rounded-full bg-accent text-white" data-testid="notifications-unread-count">{unread}</Badge>}
          </h1>
          {unread > 0 && (
            <Button data-testid="notifications-mark-all" size="sm" variant="outline" className="rounded-sm gap-1.5" onClick={markAll}>
              <CheckCheck className="h-4 w-4" /> Tout marquer comme lu
            </Button>
          )}
        </div>
        <div className="mt-4 flex gap-2">
          {FILTERS.map(([v, l]) => (
            <button key={v} data-testid={`notif-filter-${v}`} onClick={() => setFilter(v)}
              className={`px-3 py-1.5 text-sm font-semibold border transition-colors ${filter === v ? "bg-primary text-white border-primary" : "bg-card border-border hover:border-accent"}`}>
              {l}
            </button>
          ))}
        </div>
        <div className="mt-4 space-y-2" data-testid="notifications-list">
          {shown.map((n) => (
            <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => !n.read && markRead(n.id)}
              className={`w-full text-left border bg-card p-4 transition-colors ${n.read ? "border-border opacity-70" : "border-accent/40 hover:border-accent"}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-sm font-semibold">{n.title}</div>
                  <div className="mt-0.5 text-sm text-muted-foreground">{n.body}</div>
                  {n.created_at && <div className="mt-1 text-xs text-muted-foreground">{new Date(n.created_at).toLocaleString()}</div>}
                </div>
                {!n.read && <span className="mt-1 h-2.5 w-2.5 rounded-full bg-accent shrink-0" />}
              </div>
            </button>
          ))}
          {shown.length === 0 && <p className="border border-dashed border-border p-10 text-center text-sm text-muted-foreground">Aucune notification.</p>}
        </div>
      </div>
    </div>
  );
}
